module.exports = __webpack_public_path__ + "static/media/kia-provider.fab3a83b.svg";